import { render, staticRenderFns } from "./vs-form-geom-layers.vue?vue&type=template&id=40fd1791&scoped=true"
import script from "./vs-form-geom-layers.vue?vue&type=script&lang=js"
export * from "./vs-form-geom-layers.vue?vue&type=script&lang=js"
import style0 from "./vs-form-geom-layers.vue?vue&type=style&index=0&id=40fd1791&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fd1791",
  null
  
)

export default component.exports